import { grey, red } from "@mui/material/colors";

const styles = {
  activeButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: red["A400"],
    color: "white",
    "&:hover": {
      backgroundColor: red["A700"],
    },
  },
  inactiveButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    backgroundColor: grey[500],
    color: grey[300],
  },
  cancelButton: {
    width: "120px",
    borderRadius: "0.5rem",
    height: "38px",
    color: red["A400"],
    backgroundColor: red["50"],
  },
  buttonsContainer: {
    display: "flex",
    justifyContent: "end",
    width: "100%",
    padding: 0,
    marginTop: 36,
    gap: 12,
  },
  circularProgress: {
    color: "white",
  },
  title: {
    textAlign: "center",
    fontWeight: "bold",
    color: grey[800],
    marginBottom: 5,
  },
  subtitle: {
    textAlign: "center",
    color: grey[800],
    marginBottom: 36,
  },
  dialog: {
    borderRadius: "16px",
  },
  mainContainer: {
    padding: 30,
  },
};

export default styles;
